import { createSelector } from '@reduxjs/toolkit';

import { useCardContext } from '@/microfrontends/listing/shared/context/CardContext';
import { type TCardContextData } from '@/microfrontends/listing/shared/types/TCardContextData';

import { type IOfferForDesktopEnrichedV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopEnrichedV3Schema';
import { type IOfferForDesktopV3Schema } from '@/repositories/generated/shared/search-offers/entities/offer_for_desktop/OfferForDesktopV3Schema';
import { type IPublisherSchema } from '@/repositories/generated/shared/search-offers/entities/publisher/PublisherSchema';

import { formatPhone } from '../../utils/formatPhone';

const cardContextDataSelector = (state: TCardContextData): TCardContextData => state;
export const cardOfferSelector = createSelector(cardContextDataSelector, state => state.offer);

export function useCardOfferContext(): IOfferForDesktopEnrichedV3Schema {
  return cardOfferSelector(useCardContext());
}

export const cardOfferDataSelector = createSelector(cardOfferSelector, state => state.data);

export function useCardOfferDataContext(): IOfferForDesktopV3Schema {
  return cardOfferDataSelector(useCardContext());
}

const cardOfferPublisherSelector = createSelector(cardOfferSelector, state => state.publisher);

export function useCardOfferPublisherContext(): IPublisherSchema {
  return cardOfferPublisherSelector(useCardContext());
}

export function usePrettyPublisherPhones(): string[] {
  const { phones } = cardOfferPublisherSelector(useCardContext());

  return phones.map(formatPhone);
}

const cardOfferIsMultiSelector = createSelector(cardOfferDataSelector, state => state.areaParts);

export function useCardOfferIsMulti(): boolean {
  const areaParts = cardOfferIsMultiSelector(useCardContext());

  return !!areaParts;
}

export const cardOfferExtendedPropertiesSelector = createSelector(
  cardOfferDataSelector,
  state => state.extendedProperties,
);

export function useCardOfferIsTop3(): boolean {
  const properties = cardOfferExtendedPropertiesSelector(useCardContext());

  return !!properties?.offerServices?.isTop3;
}

export function useCardOfferIsEarlyAccessFlow(): boolean {
  const properties = cardOfferExtendedPropertiesSelector(useCardContext());

  return !!properties.isEarlyAccessEnabled;
}

export function useCardOfferId(): number {
  const { id } = cardOfferSelector(useCardContext());

  return id;
}
